//:: AUTH
export const AUTH_REGISTER_REQUEST = "AUTH_REGISTER_REQUEST";
export const AUTH_CREATE_GUEST = "AUTH_CREATE_GUEST";
export const AUTH_RESEND_CONFIMATION = "AUTH_RESEND_CONFIMATION";
export const AUTH_CONFIRMATION = "AUTH_CONFIRMATION";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_CUSTOMER_CONTACT = "AUTH_CUSTOMER_CONTACT";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_CHECK_LOGIN = "AUTH_CHECK_LOGIN";
export const AUTH_INVITE = "AUTH_INVITE";
export const AUTH_PASSWORD_RESET_REQUEST = "AUTH_PASSWORD_RESET_REQUEST";
export const AUTH_PASSWORD_RESET_COMPLETE = "AUTH_PASSWORD_RESET_COMPLETE";
export const AUTH_VERIFY = "AUTH_VERIFY";

//:: CART
export const CART_CHECKOUT = "CART_CHECKOUT";
export const CART_ADD_SUBMISSION = "CART_ADD_SUBMISSION";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_CLEAR_ITEMS = "CART_CLEAR_ITEMS";
export const CART_ADD_PRODUCT = "CART_ADD_PRODUCT";

//:: SUBMISSION CLIPBOARD
export const SC_COPY_SUBMISSION = "SC_COPY_SUBMISSION";

//:: PROJECT
export const PROJECT__APPLY_CURRENT = "PROJECT__APPLY_CURRENT";

//:: PROJECT STORE
export const SET_PROJECT_INFO = "SET_PROJECT_INFO";
